<div class="clr-row clr-justify-content-center margin-0" style="margin-top: 3em">
  <div class="clr-col-xl-8 clr-col-lg-9 clr-col-md-10 clr-col-sm-11 clr-col-xs-12">
    <app-loading-indicator></app-loading-indicator>
    <h2>{{__('info')}}</h2>
  </div>
</div>
